/* Dreavaya product page (WS2): A6/A5 size switch, full-media gallery with the shake video, "your page" pockets with
   Waya's picks + picker sheet, add to cart via the drawer. Runs after dv-cart.js / dv-catalog.js (DOMContentLoaded). */
document.addEventListener('DOMContentLoaded', function () {
  const root = document.querySelector('[data-dv-product]');
  if (!root) return;
  const D = JSON.parse(root.querySelector('[data-dv-product-json]').textContent), doc = document;
  const dec = (s) => { const d = doc.createElement('textarea'); d.innerHTML = s == null ? '' : s; return d.value; };  // locale strings arrive HTML-escaped
  const T = {}; Object.keys(D.t).forEach((k) => { T[k] = dec(D.t[k]); });
  D.short = dec(D.short);
  const DV = () => window.DV || {};
  const $ = (s, el) => (el || root).querySelector(s), $$ = (s, el) => Array.from((el || root).querySelectorAll(s));
  const money = (c) => (DV().cart && DV().cart.fmt ? DV().cart.fmt(c) : (c / 100).toFixed(2));
  const pub = (n, d) => { try { if (DV().track) DV().track.publish(n, d); else Shopify.analytics.publish(n, d); } catch (e) {} };
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const sized = (u, w) => (u ? (/[?&]width=\d+/.test(u) ? u.replace(/([?&]width=)\d+/, '$1' + w) : u + (u.includes('?') ? '&' : '?') + 'width=' + w) : '');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let variant = D.variants.find((x) => x.id === D.cur) || D.variants[0];
  let size = variant.size, n = D.isBook ? D.defaultTier || 1 : 1;
  let picks = [];  // pockets 2..4: {h, t, c, img, v, v5, d, b, waya}
  const tagBtns = $$('[data-dv-tier]');
  const totalFor = (k) => { const b = tagBtns.find((t) => +t.dataset.dvTier === k); return b ? +b.dataset.dvTotal : variant.price * k; };
  const pickId = (p) => (size === 'A5' ? p.v5 || p.d : p.v || p.d);  // the pocket's book in the shopper's size, where it exists
  const has = (p) => !!(size === 'A5' ? p.v5 : p.v);  // the design comes in the size on screen
  const pickSize = (p) => (p.v5 && pickId(p) === p.v5 ? 'A5' : 'A6');  // the size that pocket will really add

  /* ---------- gallery: one scroll-snap track; dots on phones, thumbnails on computers ---------- */
  const track = $('[data-dv-gal-track]'), slides = track ? Array.from(track.children) : [];
  const thumbs = $$('.dv-gal__thumbs > button'), dots = $$('.dv-gal__dots > span'), picNo = $('[data-dv-pic-no]'), picN = $('[data-dv-pic-n]');
  let cur = 0;  // position among the visible slides (A5 hides the A6-only "fits" slide); thumbs[k] belongs to slides[k]
  const vis = () => slides.filter((s) => !s.hidden);
  const go = (i) => { if (track) track.scrollTo({ left: Math.max(0, Math.min(vis().length - 1, i)) * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' }); };
  const mark = (i) => {
    const vv = vis(); cur = i; if (picNo) picNo.textContent = i + 1; if (picN) picN.textContent = vv.length;
    thumbs.forEach((b, k) => b.classList.toggle('is-on', slides[k] === vv[i]));
    dots.forEach((d, k) => { d.hidden = k >= vv.length; d.classList.toggle('is-on', k === Math.min(i, dots.length - 1)); });
  };
  if (track && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => es.forEach((e) => { const i = vis().indexOf(e.target); if (e.isIntersecting && i >= 0) mark(i); }), { root: track, threshold: 0.6 });
    slides.forEach((s) => io.observe(s));
  }
  thumbs.forEach((b, k) => b.addEventListener('click', () => go(vis().indexOf(slides[k]))));
  if (track) track.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); go(cur + (e.key === 'ArrowRight' ? 1 : -1)); } });

  /* shake video: loads on intent or when reached, plays muted while ≥60% visible, tap pauses / replays */
  const vs = $('[data-slide="video"]'), pv = vs && $('[data-dv-pvid]', vs);
  if (pv) {
    const src = pv.querySelector('source'), playB = $('[data-dv-pplay]', vs), again = $('[data-dv-replay]', vs);
    const conn = navigator.connection || {};
    const noAuto = reduced || conn.saveData || /2g/.test(conn.effectiveType || '') || (window.Shopify && Shopify.designMode);
    let loaded = false, held = false, seen = false;
    const load = () => { if (loaded) return; loaded = true; src.src = src.dataset.src; pv.load(); };
    const play = () => { load(); const p = pv.play(); if (p && p.catch) p.catch((err) => { if (err && err.name !== 'AbortError') playB.hidden = false; }); };
    src.addEventListener('error', () => { const hd = src.dataset.hd; if (hd && src.getAttribute('src') !== hd) { src.src = hd; pv.load(); if (seen) play(); } });
    pv.addEventListener('playing', () => { vs.classList.add('is-playing'); playB.hidden = again.hidden = true; });
    if (noAuto) playB.hidden = false;
    else {
      // no prefetch just because the slide is next door (it always is): the clip starts loading on a swipe / scroll of the
      // track or a hover/focus on its thumbnail; the >=60% observer below loads + plays it once its slide is reached
      // (product.ad: slide 1, so right away). Armed after the page load, so it never competes with the first picture.
      const vt = thumbs[slides.indexOf(vs)];
      const arm = () => {
        ['pointerdown', 'touchstart', 'scroll'].forEach((t) => track.addEventListener(t, load, { once: true, passive: true }));
        if (vt) { vt.addEventListener('pointerenter', load, { once: true }); vt.addEventListener('focus', load, { once: true }); }
      };
      if (doc.readyState === 'complete') arm(); else addEventListener('load', arm, { once: true });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => {
        seen = e.intersectionRatio >= 0.6;
        if (seen) { if (!noAuto && !held) play(); } else { if (!pv.paused) pv.pause(); held = false; }
      }, { threshold: [0, 0.6] }).observe(vs);
    }
    vs.addEventListener('click', (e) => {
      if (e.target.closest('[data-dv-replay]')) { pv.currentTime = 0; held = false; return play(); }
      if (e.target.closest('[data-dv-pplay]') || pv.paused) { held = false; return play(); }
      pv.pause(); held = true; again.hidden = false;
    });
    doc.addEventListener('visibilitychange', () => { if (doc.hidden && !pv.paused) pv.pause(); });
  }

  /* ---------- spec notebook: tabs delegated from document, so they keep working after the A6/A5 swap ---------- */
  let book = doc.querySelector('[data-dv-spec]');
  const books = {}, alt = doc.querySelector('template[data-dv-spec-alt]');
  if (book) books[D.fmt] = book;
  function openTab(k) {
    if (!book || !k) return;
    if (!book.querySelector(`[data-dv-spec-tab="${k}"]`)) k = (book.querySelector('[data-dv-spec-tab]') || { dataset: {} }).dataset.dvSpecTab;  // A5 has no Photos tab
    book.querySelectorAll('[data-dv-spec-tab]').forEach((b) => b.setAttribute('aria-selected', String(b.dataset.dvSpecTab === k)));
    book.querySelectorAll('[data-dv-spec-panel]').forEach((p) => { p.hidden = p.dataset.dvSpecPanel !== k; });
    const on = book.querySelector(`[data-dv-spec-tab="${k}"]`), bar = on && on.parentNode;
    if (bar && bar.scrollWidth > bar.clientWidth) bar.scrollTo({ left: on.offsetLeft - 12, behavior: 'smooth' });
  }
  doc.addEventListener('click', (e) => { const b = e.target.closest('[data-dv-spec] [data-dv-spec-tab]'); if (b) openTab(b.dataset.dvSpecTab); });
  doc.addEventListener('keydown', (e) => {
    if ((e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') || !e.target.closest('[data-dv-spec]')) return;
    const tabs = Array.from(e.target.closest('[data-dv-spec]').querySelectorAll('[data-dv-spec-tab]')), i = tabs.indexOf(doc.activeElement); if (i < 0) return;
    const nx = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length]; nx.focus(); openTab(nx.dataset.dvSpecTab);
  });
  function swapBook(sz) {
    if (!book) return;
    if (!books[sz] && alt && alt.dataset.dvSpecAlt === sz) { const el = alt.content.querySelector('[data-dv-spec]'); if (el) books[sz] = doc.importNode(el, true); }
    const nb = books[sz]; if (!nb || nb === book) return;
    const k = (book.querySelector('[data-dv-spec-tab][aria-selected="true"]') || {}).dataset;
    book.replaceWith(nb); book = nb; openTab(k && k.dvSpecTab);
  }

  /* ---------- A6 / A5 ---------- */
  const front = $('[data-dv-front]');
  function setSize(sz) {
    const nv = D.variants.find((x) => x.size === sz && x.available) || D.variants.find((x) => x.size === sz);
    if (!nv || nv === variant) return;
    variant = nv; size = sz;
    if (front) {
      const swap = () => { front.srcset = `${nv.front600} 600w, ${nv.front900} 900w, ${nv.front} 1100w`; front.src = nv.front; front.alt = D.short + ' — ' + sz + (D.code ? ' — N° ' + D.code : ''); };
      // a quick page turn around the left edge (220 ms in all)
      if (reduced || !front.animate) swap();
      else front.animate([{ transform: 'none' }, { transform: 'perspective(900px) rotateY(8deg)', opacity: 0.55 }], { duration: 110, easing: 'ease-in' }).onfinish = () => { swap(); front.animate([{ transform: 'perspective(900px) rotateY(8deg)', opacity: 0.55 }, { transform: 'none', opacity: 1 }], { duration: 110, easing: 'ease-out' }); };
    }
    const th = $('[data-dv-front-th]'); if (th) th.src = nv.thumb;
    $$('[data-fmt]').forEach((el) => { el.hidden = el.dataset.fmt !== sz; });
    const fi = vis().findIndex((s) => s.dataset.slide === 'front'); mark(Math.min(cur, vis().length - 1)); go(fi);
    const head = $('[data-dv-head]'); if (head) head.textContent = sz === 'A5' ? T.head_a5 : T.head_a6;
    const kit = $('[data-dv-kit]'), kitRow = $('[data-dv-kit-row]');
    if (kitRow) { kitRow.hidden = sz !== 'A6'; if (sz !== 'A6') kit.checked = false; }
    swapBook(sz);
    // keep every other parameter (utm_*, ttclid, fbclid, view): only variant changes
    try { const u = new URL(location.href); u.searchParams.set('variant', nv.id); history.replaceState(history.state, '', u); } catch (e) {}
    pub('dv_size_switch', { handle: D.handle, size: sz });
    // a Waya pick that doesn't come in the new size is picked again; the shopper's own picks stay as they are
    picks = picks.map((p) => (p && p.waya && !has(p) ? null : p));
    render(); if (n > 1) prefill();
  }
  const sizeBtns = $$('[data-dv-size]');
  sizeBtns.forEach((b, i) => {
    b.addEventListener('click', () => setSize(b.dataset.dvSize));
    b.addEventListener('keydown', (e) => { if (!/^Arrow/.test(e.key)) return; e.preventDefault(); const nb = sizeBtns[(i + 1) % sizeBtns.length]; nb.focus(); setSize(nb.dataset.dvSize); });
    // warm the other size's front picture the moment the shopper reaches for it
    const warm = () => { const v = D.variants.find((x) => x.size === b.dataset.dvSize); if (v && front && !b._w) { b._w = new Image(); b._w.sizes = front.sizes; b._w.srcset = `${v.front600} 600w, ${v.front900} 900w, ${v.front} 1100w`; } };
    b.addEventListener('pointerenter', warm); b.addEventListener('touchstart', warm, { passive: true }); b.addEventListener('focus', warm);
  });

  /* ---------- pockets: pocket 1 is this design; 2..n are Waya's picks from this series until the shopper swaps them ---------- */
  let pool = null, fetched = false;
  const got = new Set();  // collections already merged into the pool for the size top-up
  // the picture of the size this pocket will add: A5 front when the page is on A5 and the design has one
  const pimg = (p) => (size === 'A5' && p.v5 && p.img5 ? p.img5 : p.img);
  const fromCard = (c) => { const d = c.dataset; return { h: d.handle, t: d.title, c: d.code, img: d.img, img5: d.img5 || '', v: +d.v || 0, v5: +d.v5 || 0, d: +d.default || 0, b: d.best === '1', av: !c.classList.contains('is-soldout') && !!c.querySelector('[data-dv-quick]') }; };
  const fromJson = (it) => ({ h: it.h, t: it.t, c: it.c, img: sized(it.i, 160), img5: it.i5 ? sized(it.i5, 160) : '', v: it.v || 0, v5: it.v5 || 0, d: it.d || 0, b: !!it.b, av: it.av !== false });
  const clean = (list) => list.filter((x) => x.h !== D.handle && x.av && x.d).sort((a, b) => b.b - a.b);  // best sellers first, collection order otherwise
  function fillFrom() {
    const used = new Set(picks.filter(Boolean).map((p) => p.h));
    for (let i = 0; i < n - 1; i++) {
      if (picks[i]) continue;
      const it = pool.find((x) => !used.has(x.h) && has(x)) || pool.find((x) => !used.has(x.h)); if (!it) break;  // the other size only as a last resort
      used.add(it.h); picks[i] = Object.assign({}, it, { waya: true });
    }
  }
  const odd = () => picks.slice(0, n - 1).some((p) => p && p.waya && !has(p));
  async function prefill() {
    if (!pool) pool = clean($$('[data-dv-rail] [data-dv-card]', doc).map(fromCard));
    if (!pool.length && !fetched && DV().cat) { fetched = true; try { pool = clean((await DV().cat.get(D.series || D.bestHandle)).items.map(fromJson)); } catch (e) {} }
    fillFrom(); render();
    // the rail holds 12 cards and most designs are A6 only: when a Waya pick had to be the other size, merge the whole
    // series (then, on an A5 page, the A5 collection) into the pool and pick again in the shopper's size
    for (const h of [D.series, size === 'A5' ? (window.DV_CFG || {}).a5Handle : '']) {
      if (!h || got.has(h) || !odd() || !DV().cat) continue;
      got.add(h);
      try { const more = clean((await DV().cat.get(h)).items.map(fromJson)); pool = pool.concat(more.filter((x) => !pool.some((y) => y.h === x.h))); } catch (e) { continue; }
      picks = picks.map((p) => (p && p.waya && !has(p) ? null : p)); fillFrom(); render();
    }
  }
  function setTier(k) {
    n = k; pub('dv_tier_select', { tier: k });
    // shrinking keeps the shopper's own picks first
    picks = picks.filter((p) => p && !p.waya).concat(picks.filter((p) => p && p.waya)).slice(0, n - 1);
    render(); if (n > 1) prefill();
  }

  /* ---------- picker sheet (lazy: ?view=dvjson through DV.cat) ---------- */
  const sheet = $('[data-dv-picker-sheet]'), plist = sheet && $('[data-dv-plist]', sheet), pmsg = sheet && $('[data-dv-pmsg]', sheet);
  const pcode = sheet && $('[data-dv-pcode]', sheet), pin = sheet && $('[data-dv-pcode-in]', sheet);
  let slot = 0, ptab = null, shown = [], codeT = 0;
  const msg = (s) => { if (pmsg) { pmsg.textContent = s || ''; pmsg.hidden = !s; } };
  function list(items, keepThis) {
    const fits = (it) => !!(size === 'A5' ? it.v5 : it.v);
    shown = items.filter((it) => it.av !== false && (keepThis || it.h !== D.handle));
    shown = shown.filter(fits).concat(shown.filter((it) => !fits(it)));  // designs in the shopper's size first (order kept within each)
    const on = picks[slot] && picks[slot].h;
    plist.innerHTML = shown.map((it, i) => `<li><button type="button" class="dv-pick${it.h === on ? ' is-on' : ''}" data-dv-pick="${i}"><span class="dv-sleeve" style="--paper:var(--dv-paper-${esc(it.p || 'cream')})"><img src="${esc(sized(size === 'A5' && it.v5 && it.i5 ? it.i5 : it.i, 160))}" alt="" width="160" height="160" loading="lazy"></span><span class="dv-pick__t">${esc(it.t)}</span>${it.c ? `<span class="dv-mono dv-pick__c">N° ${esc(it.c)}</span>` : ''}${(size === 'A5' ? it.v5 : it.v) ? '' : `<span class="dv-pick__sz">${size === 'A5' ? 'A6' : 'A5'}</span>`}</button></li>`).join('');
  }
  function showTab(k) {
    ptab = k;
    $$('[data-dv-ptab]', sheet).forEach((b) => b.setAttribute('aria-selected', String(b.dataset.dvPtab === k)));
    pcode.hidden = k !== 'code'; plist.innerHTML = ''; shown = []; msg('');
    if (k === 'code') { if (pin.value) lookup(); return; }
    if (!DV().cat) return msg(T.picker_error);
    msg(T.picker_loading);
    DV().cat.get(k === 'series' ? D.series : D.bestHandle).then((d) => { if (ptab === k) { msg(''); list(d.items); } }).catch(() => { if (ptab === k) msg(T.picker_error); });
  }
  function lookup() {
    const q = pin.value.trim(); plist.innerHTML = ''; shown = [];
    if (!q) return msg('');
    if (!DV().cat) return msg(T.picker_error);
    const valid = !!DV().cat.norm(q);
    DV().cat.byCode(q).then((items) => {
      if (ptab !== 'code' || pin.value.trim() !== q) return;
      if (valid) pub('dv_code_lookup', { hit: items.length > 0, where: 'picker' });
      // a number the shopper typed may be this very design (a second copy as a gift), so it is not filtered out here
      if (items.length) { msg(''); list(items, true); } else msg(T.picker_none);
    }).catch(() => msg(T.picker_error));
  }
  function openSheet(i) {
    if (!sheet) return;
    slot = i; sheet.hidden = false; doc.documentElement.classList.add('dv-lock');
    requestAnimationFrame(() => sheet.classList.add('is-open'));
    showTab(ptab || (D.series ? 'series' : 'best'));
    setTimeout(() => { const t = $('[data-dv-ptab][aria-selected="true"]', sheet); if (t) t.focus(); }, 60);
  }
  function closeSheet() {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open'); sheet.hidden = true; doc.documentElement.classList.remove('dv-lock');
    const b = $(`[data-slot="${slot}"]`); if (b) b.focus();
  }
  if (sheet) {
    sheet.addEventListener('click', (e) => {
      if (e.target.closest('[data-dv-sheet-close]')) return closeSheet();
      const t = e.target.closest('[data-dv-ptab]'); if (t) { t.focus(); return showTab(t.dataset.dvPtab); }  // Safari doesn't focus clicked buttons
      const p = e.target.closest('[data-dv-pick]'); if (!p) return;
      const it = shown[+p.dataset.dvPick]; if (!it) return;
      picks[slot] = Object.assign(fromJson(it), { waya: false });
      render(); closeSheet();
    });
    // on the document, not the sheet: a click on the sheet's text or padding moves focus to <main>, outside the sheet
    doc.addEventListener('keydown', (e) => {
      if (sheet.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); return closeSheet(); }
      if (e.key !== 'Tab') return;
      // keep keyboard focus inside the sheet
      const f = $$('button, input', sheet).filter((x) => x.offsetParent), a = f[0], z = f[f.length - 1];
      if (!sheet.contains(doc.activeElement)) { e.preventDefault(); (e.shiftKey ? z : a).focus(); return; }
      if (e.shiftKey && doc.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && doc.activeElement === z) { e.preventDefault(); a.focus(); }
    });
    pin.addEventListener('input', () => { clearTimeout(codeT); codeT = setTimeout(lookup, 250); });
  }

  /* ---------- render ---------- */
  const slotsBox = $('[data-dv-slots]'), slotList = $('[data-dv-slot-list]'), fill4 = $('[data-dv-fill4]');
  const express = $('[data-dv-express]'), expressId = $('[data-dv-express-id]'), sticky = $('[data-dv-sticky]');
  function pocketsHtml() {
    let h = `<span class="dv-sleeve dv-prod__slot is-this"><img src="${esc(variant.thumb)}" alt="${esc(D.short)}" width="160" height="160"></span>`;
    for (let i = 0; i < n - 1; i++) {
      const p = picks[i], ps = p && pickSize(p), xs = p && ps !== size;
      h += p
        ? `<button type="button" class="dv-sleeve dv-prod__slot${p.waya ? ' is-waya' : ''}" data-slot="${i}" aria-label="${esc(T.pocket.replace('%N%', i + 2).replace('%T%', p.t + (xs ? ' · ' + ps : '')))}"><img src="${esc(pimg(p))}" alt="" width="160" height="160">${xs ? `<i class="dv-prod__slot-sz">${ps}</i>` : ''}${p.waya ? `<small>${esc(T.waya)}</small>` : ''}</button>`
        : `<button type="button" class="dv-prod__slot is-empty" data-slot="${i}" aria-label="${esc(T.empty.replace('%N%', i + 2))}">+</button>`;
    }
    return h;
  }
  function render() {
    tagBtns.forEach((b) => b.setAttribute('aria-pressed', String(+b.dataset.dvTier === n)));
    sizeBtns.forEach((b) => { const on = b.dataset.dvSize === size; b.setAttribute('aria-checked', String(on)); b.tabIndex = on ? 0 : -1; });
    $('[data-dv-price]').textContent = money(variant.price);
    const was = $('[data-dv-was]');
    if (was) { was.hidden = !(variant.compare > variant.price); was.textContent = variant.compare > variant.price ? money(variant.compare) : ''; }
    const stock = $('[data-dv-stock]'); if (stock) stock.hidden = variant.available;
    if (slotsBox) { slotsBox.hidden = n < 2; slotList.innerHTML = n < 2 ? '' : pocketsHtml(); }
    const filled = picks.slice(0, n - 1).filter(Boolean).length, left = n - 1 - filled;
    const total = totalFor(n), pickTxt = T.pick_n.replace('X', left);
    const label = !variant.available ? T.sold_out : left > 0 ? pickTxt : n === 1 ? `${T.add} · ${money(total)}` : T.add_n.replace('%N%', n).replace('%P%', money(total));
    $$('[data-dv-add-main]').forEach((b) => { b.disabled = !variant.available; b.textContent = b.closest('[data-dv-sticky]') ? (variant.available && left > 0 ? pickTxt : b.dataset.short) : label; });
    if (fill4) fill4.hidden = n !== 1 || !variant.available;
    if (sticky) {
      const kit = $('[data-dv-kit]'), kitOn = !!(kit && kit.checked && size === 'A6'), tot = sticky.querySelector('[data-dv-sticky-total]');
      tot.textContent = money(total);
      if (kitOn) { const k = doc.createElement('small'); k.className = 'dv-prod__skit'; k.textContent = ' + ' + money(+kit.dataset.price); tot.appendChild(k); }
      sticky.classList.toggle('has-kit', kitOn);  // narrow phones drop the mini pockets then, so the total stays readable
      sticky.querySelector('[data-dv-sticky-sub]').textContent = n === 1 ? (D.isBook ? size + ' · ' + D.short : D.short) : T.covers.replace('X', 1 + filled).replace('Y', n);
      const si = sticky.querySelector('[data-dv-sticky-img]'); if (si) si.src = sized(variant.thumb, 120);
      const mini = sticky.querySelector('[data-dv-sticky-mini]');
      if (mini) { const imgs = [variant.thumb].concat(picks.slice(0, n - 1).filter(Boolean).map((p) => pimg(p))); mini.innerHTML = [0, 1, 2, 3].map((i) => (imgs[i] ? `<span class="is-on"><img src="${esc(sized(imgs[i], 120))}" alt=""></span>` : `<span${i < n ? ' class="is-want"' : ''}></span>`)).join(''); }
    }
    if (express) express.hidden = n !== 1 || !variant.available || express.hasAttribute('data-off');
    if (expressId) expressId.value = variant.id;
  }

  /* ---------- clicks ---------- */
  root.addEventListener('click', (e) => {
    const go2 = e.target.closest('[data-dv-go]');
    if (go2 && book) {
      e.preventDefault(); openTab(go2.dataset.dvGo);
      const tab = book.querySelector(`[data-dv-spec-tab="${go2.dataset.dvGo}"]`);
      book.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      if (tab) setTimeout(() => tab.focus({ preventScroll: true }), 400);
      return;
    }
    const tier = e.target.closest('[data-dv-tier]'); if (tier) return setTier(+tier.dataset.dvTier);
    if (e.target.closest('[data-dv-fill4]')) return setTier(4);
    const sl = e.target.closest('[data-slot]'); if (sl) return openSheet(+sl.dataset.slot);
    const add = e.target.closest('[data-dv-add-main]');
    if (!add || add.disabled || !DV().cart) return;
    const ext = picks.slice(0, n - 1), left = n - 1 - ext.filter(Boolean).length;
    if (left > 0) { for (let i = 0; i < n - 1; i++) if (!picks[i]) return openSheet(i); }  // Waya had nothing to offer: let the shopper pick
    const counts = {};
    [variant.id].concat(ext.map(pickId)).forEach((id) => { counts[id] = (counts[id] || 0) + 1; });
    const items = Object.keys(counts).map((id) => ({ id: +id, quantity: counts[id] }));
    const kit = $('[data-dv-kit]'); if (kit && kit.checked && size === 'A6') items.push({ id: +kit.value, quantity: 1 });
    add.disabled = true;
    // Waya's charm at the end of the bookmark ribbon gives a little swing
    const charm = $('[data-dv-charm]'); if (charm) { charm.classList.remove('is-swing'); void charm.offsetWidth; charm.classList.add('is-swing'); }
    DV().cart.add(items).then(() => { if (n > 1) pub('dv_bundle_add', { tier: n, count: n, series: D.series, landing: doc.body.dataset.dvTpl || '' }); })
      .catch((err) => alert(err.message)).finally(render);
  });
  const kitBox = $('[data-dv-kit]'); if (kitBox) kitBox.addEventListener('change', render);

  // sticky bar appears once the main button scrolls out of view (phones). The slim ad page also shows it before the
  // shopper reaches the button, so paid traffic sees name, price and Add on the first screen (computers hide it in CSS)
  const mainBtn = $('.dv-prod__buy [data-dv-add-main]'), slimPg = root.classList.contains('dv-prod--slim');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(([en]) => sticky.classList.toggle('is-on', !en.isIntersecting && (slimPg || en.boundingClientRect.top < 0))).observe(mainBtn);
  }
  render();
  if (n > 1) prefill();
});
